import { Command } from 'commands/Commands';

export class ChangeStates extends Command {
  type: string = 'ChangeStates';
  priority: number = 100;
}
